module.exports = __webpack_public_path__ + "static/media/tone2_good.17fd554f.svg";